// @flow

import React, { useRef, useState } from "react";
import { localize } from "redux-i18n";

import { SchemaForm, Button, View, Text } from "@components";
import actionCreators from "@modules/service/actionCreator";
import type {
  ServiceSettingsContainer,
  ServiceSettings,
} from "@modules/service/reducer/service-settings/types";
import { split } from "@transformers/schema";

import uiSchema from "./ui-schema";

type Props = $Exact<{
  serviceSettings: Object,
  settings: ServiceSettingsContainer,
  schema: Object,
  editDisabed: boolean,
  clientId: ?number,
  updateSettings: typeof actionCreators.UpdateServiceSettings,
  ...PropsFromLocalize,
}>;

type OwnState = $Exact<{
  edit: boolean,
}>;

const ComplianceMeasures = props => {
  const formRef = useRef(null);
  const [edit, setEdit] = useState(false);

  const submitForm = () => {
    formRef.current.submit();
  };

  const toggleEdit = () => {
    setEdit(prev => !prev);
  };

  const submitHandler = (formData: Object) => {
    props.updateSettings({
      clientId: props.clientId,
      settings: {
        ...formData,
        rtwDiscussionType: "EMPLOYEE_LED",
        timeInAdvanceAbsenceCanBeOpened: 5184000, // 60 days in seconds
        allowEmployeeToUpdateAndCloseAbsencesInSameTransaction: true,
        allowEmployeeToOpenAndCloseAbsencesInSameTransaction: true,
      },
    });
    toggleEdit();
  };

  const getUiSchema = () => {
    return uiSchema(props.t);
  };

  const schema = () => {
    return split(props.schema, ["taskKpiExcludeHolidays", "taskKpiExcludeWeekends"]);
  };

  return props.settings?.active ? (
    <View gap={3}>
      <View direction="row" justifyContent="space-between" alignItems="center">
        <Text type="h5">{props.t("COMPLIANCE_MEASURES")}</Text>
        <View direction="row" justifyContent="space-between" gap="4">
          {!edit ? (
            <Button materialIcon="edit" onClick={toggleEdit} disabled={props.editDisabed}>
              {props.t("EDIT")}
            </Button>
          ) : (
            <View direction="row" gap="4">
              <Button color="secondary" onClick={toggleEdit}>
                {props.t("CANCEL")}
              </Button>
              <Button materialIcon="replay_circle_filled" className="ml-2" onClick={submitForm}>
                {props.t("SUBMIT")}
              </Button>
            </View>
          )}
        </View>
      </View>
      <SchemaForm
        schema={schema()}
        uiSchema={getUiSchema()}
        formData={props.settings.active}
        ref={formRef}
        readonly={!edit}
        onSubmit={submitHandler}
        externalSubmit
        boxGrid
      />
    </View>
  ) : (
    <div />
  );
};

export default localize()(ComplianceMeasures);
